// BaseRangeFilter.jsx
import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

/**
 * Component tái sử dụng cho các filter kiểu khoảng thời gian
 * @param {string} name - Tên trường filter (ví dụ: 'created_at')
 * @param {object} query - object query (đã parse từ URL)
 * @param {function} onChangeFilter - callback khi thay đổi filter
 * @param {string} fromSuffix - mặc định: `${name}_from`
 * @param {string} toSuffix - mặc định: `${name}_to`
 * @param {string[]} placeholder - placeholder cho RangePicker
 */
const BaseRangeFilter = ({
    name,
    query,
    onChangeFilter,
    fromSuffix = `${name}_from`,
    toSuffix = `${name}_to`,
    placeholder = ['Từ ngày', 'Đến ngày'],
    type = 'date',
    width = '100%',
    ...props
}) => {
    let defaultRange = [null, null];
    let format = 'YYYY-MM-DD';

    if (type === 'month-day') {
        format = 'MM-DD';
        defaultRange = [
            query[fromSuffix] ? moment(query[fromSuffix], 'MM-DD') : null,
            query[toSuffix] ? moment(query[toSuffix], 'MM-DD') : null
        ];
    } else {
        format = 'YYYY-MM-DD';
        defaultRange = [
            query[fromSuffix] ? moment(query[fromSuffix], 'YYYY-MM-DD') : null,
            query[toSuffix] ? moment(query[toSuffix], 'YYYY-MM-DD') : null
        ];
    }

    //console.log('defaultRange', defaultRange);

    return (
        <RangePicker
            {...props}
            format={format}
            placeholder={placeholder}
            style={{ width: width }}
            onChange={(val) => onChangeFilter(name, val)}
            defaultValue={defaultRange}
            value={defaultRange}
            allowClear
        />
    );
};

export default BaseRangeFilter;
